import { DEAL_RENT_PREPAYMENT } from '../../constants/dealRentPrepayment';
import { IAbUseExperiment } from '../../types/abUseExperiments';

export function isDealRentPrepaymentActive(experiments: IAbUseExperiment[] = []) {
  const experiment = experiments.find(exp => exp.experimentName === DEAL_RENT_PREPAYMENT);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B';
}
